// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@awc/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css``,
};

quickOrderProductListStyles.noProductListWrapper = {
    css: css`
        padding-top: 12px;
        margin-top: 12px;
        border-top: 1px solid ${color("common.border")};
    `,
};

quickOrderProductListStyles.notifyMsg = {
    css: css`
        max-width: 100%;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.removeProductClickable = {
    ...cartLineSharedStyles.removeClickable,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

quickOrderProductListStyles.qtyFieldStyles = {
    wrapper: {
        css: css`
            display: inline-block;
        `,
    },
};

quickOrderProductListStyles.cartLineContainer = {
    container: {
        css: css`
            grid-template-columns: minmax(600px, 1fr) minmax(92px, 107px);
            ${xScreen("lte", "lg")} {
                grid-template-columns: minmax(400px, 1fr) minmax(92px, 107px);
            }
            ${xScreen("lte", "md")} {
                grid-template-columns: minmax(180px, 1fr) minmax(92px, 1fr);
            }
            ${xScreen("lte", "sm")} {
                grid-template-columns: minmax(170px, 1fr) minmax(70px, 1fr);
            }
        `,
    },
    image: {
        css: css`
            ${xScreen("lte", "sm")} {
                grid-column: 1 / 3;
            }
        `,
    },
    description: {
        css: css`
            grid-column: 1 / 2;
            ${xScreen("lte", "sm")} {
                grid-row: 1 / 2;
                grid-column: 1 / 3;
            }
        `,
    },
    price: {
        css: css`
            grid-column: 1 / 2;
            ${xScreen("lte", "sm")} {
                grid-row: 2/3;
            }
        `,
    },
    actions: {
        css: css`
            grid-column: 1 / 2;
            ${xScreen("lte", "sm")} {
                grid-row: 3/4;
            }
        `,
    },
    remove: {
        css: css`
            grid-column: 2 / 3;
            grid-row: 1 / 3;
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 3;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 2 / 3;
            grid-row: 3 / 4;
            display: flex;
            align-items: baseline;
            justify-content: end;
            ${xScreen("lte", "sm")} {
                grid-row: 3/4;
                grid-column: 2 / 3;
            }
        `,
    },
    total: {
        css: css`
            grid-column: 2 / 3;
            ${xScreen("lte", "sm")} {
                grid-row: 4/5;
                grid-column: 2 / 3;
            }
        `,
    },
};
